import React from "react";
import { Link } from "react-router-dom";
import styles from "./HomeFooter.module.css";
import logo from "../../assets/images/logo_1.png";
import playStore from "../../assets/images/playstore.png";
import appStore from "../../assets/images/appstore.png";
import mascot from "../../assets/images/ifillip-mascot.png";
import { useAuth } from "../../hooks/useAuth";
import { TokenService } from "../../services/Api";

const HomeFooter = () => {
  const { logout } = useAuth();
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: "Home", path: "/" },
    { label: "Why iFillip", path: "/why-ifillip" },
    { label: "Explore More", path: "/explore-more" },
    { label: "Request Demo", path: "/request-demo" },
    { label: "Privacy Policy", path: "/privacy-policy" },
  ];
  const handleLogin = async () => {
    const user = TokenService.getUser();

    if (user) {
      try {
        await logout();
      } catch (error) {
        console.error("Logout error:", error);
      } finally {
        TokenService.clearAll();
        window.location.href = "/login";
      }
    } else {
      window.location.href = "/login";
    }
  };
  return (
    <footer className={styles.footer}>
      <div className={`${styles.container} mb-5`}>
        <div className={styles.footerContent}>
          {/* Quick Links Section */}
          <div className={styles.quickLinksSection}>
            <h3 className={styles.sectionTitle}>Quick links</h3>
            <ul className={styles.linksList}>
              <li className={styles.linkItem}>
                <span
                  onClick={handleLogin}
                  className={styles.footerLink}
                  style={{ cursor: "pointer" }}
                >
                  Login
                </span>
              </li>
              {quickLinks.map((link, index) => (
                <li key={index} className={styles.linkItem}>
                  <Link to={link.path} className={styles.footerLink}>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Logo and Description Section */}
          <div className={styles.logoSection}>
            <div className={styles.logoWrapper}>
              <img
                src={logo}
                alt="iFillip Logo"
                className={styles.footerLogo}
              />
            </div>
            <div className={styles.mascotWrapper}>
              <img
                src={mascot}
                alt="iFillip Mascot"
                className={styles.mascot}
              />
            </div>
            <p className={styles.description}>
              iFillip is a digital meeting place for the stakeholders –
              Students, Parents, Teachers & School management. Easy- to-use
              features enables seamless and active sharing of information &
              notes across the various stakeholders on any device apart
            </p>
          </div>

          {/* Reach Out Section */}
          <div className={styles.reachOutSection}>
            <h3 className={styles.sectionTitle}>Reach out</h3>
            <div className={styles.contactInfo}>
              <div className={styles.contactItem}>
                <span className={styles.contactLabel}>Phone :</span>
                <a href="tel:+919841579784" className={styles.contactValue}>
                  +91 9841579784
                </a>
              </div>
              <div className={styles.contactItem}>
                <span className={styles.contactLabel}>Email :</span>
                <a
                  href="mailto:info@ifillip.com"
                  className={styles.contactValue}
                >
                  info@ifillip.com
                </a>
              </div>
              <div className={styles.contactItem}>
                <span className={styles.contactLabel}>Web Address :</span>
                <a
                  href="https://www.bharatclouds.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.contactValue}
                >
                  www.bharatclouds.com
                </a>
              </div>
            </div>

            <div className={styles.appBadges}>
              <a
                href="https://play.google.com/store/apps/details?id=com.ifillip.school"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.badgeLink}
              >
                <img
                  src={playStore}
                  alt="Get it on Google Play"
                  className={styles.appBadge}
                />
              </a>
              <a
                href="https://apps.apple.com/us/app/ifillip/id6761409165"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.badgeLink}
              >
                <img
                  src={appStore}
                  alt="Download on the App Store"
                  className={styles.appBadge}
                />
              </a>
            </div>
          </div>
        </div>
        {/* <div className={styles.socialIcons}>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="https://x.com" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-x-twitter"></i>
              </a>
            </div> */}
      </div>

      {/* Copyright Bar */}
      <div className={styles.copyrightBar}>
        <div className={styles.copyrightContainer}>
          <p className={styles.copyrightText}>
            © {currentYear} All rights reserved | Product of{" "}
            <a
              href="https://www.bharatclouds.com"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.companyLink}
            >
              Bharat Clouds Pvt Ltd
            </a>
          </p>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <button
        className={styles.scrollTopBtn}
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="Scroll to top"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <polyline points="18,15 12,9 6,15"></polyline>
        </svg>
      </button>
    </footer>
  );
};

export default HomeFooter;
